import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import { AuthGuardService } from '../../../../../../core/services/auth/auth-guard.service';
import { ILandingPostCommentActivityPublic } from '../../../interface';
import { LandingPageDataService } from '../../../services/landing-post-data.service';
import { LandingPostService } from '../../../services/landing-post.service';
import { buildForm } from './form';

@Component({
    selector: 'app-new-comment-form',
    templateUrl: './new-comment-form.component.html',
    styleUrl: './new-comment-form.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NewCommentFormComponent {
  @Output() onNewCommentAdded =
    new EventEmitter<ILandingPostCommentActivityPublic>();
  form = buildForm();
  isShowErrors = false;
  showLoginModal = signal(false);
  picturePath = signal('');

  constructor(
    private landingPostService: LandingPostService,
    public landingPageDataService: LandingPageDataService,
    private authGuardService: AuthGuardService,
  ) {
    // effect(
    //   () => {
    //     this.picturePath.set(this.authGuardService.currentUser?.picturePath);
    //   },
    //   { allowSignalWrites: true },
    // );
  }

  async submit() {
    if (this.form.invalid) {
      this.isShowErrors = true;
      return;
    }

    if (!this.authGuardService.isLoggedIn()) {
      this.authGuardService.showLoginModal.set(true);
      return;
    }

    var res = await this.landingPostService.addComment(
      this.landingPageDataService.details()._id,
      this.form.value,
      this.landingPageDataService.isQrCode(),
    );

    this.onNewCommentAdded.emit(res.result);
    this.form.reset();
  }
}
